import {
  $,
  api,
  appState,
  HIST_KEY,
  escapeHtml,
  type LanEntry,
} from './app-state';
import { startSession } from './session';
import { newController } from './app';
import { getCurrentServerUrl } from '../shared/constants';
import { readSessionMode } from '../shared/ui/session-mode';

function loadLanHistory(): LanEntry[] {
  try {
    const raw = localStorage.getItem(HIST_KEY);
    const arr = raw ? (JSON.parse(raw) as Partial<LanEntry>[]) : [];
    if (!Array.isArray(arr)) return [];
    const normalized = arr
      .filter((entry): entry is Partial<LanEntry> => Boolean(entry && typeof entry.addr === 'string' && entry.addr.trim()))
      .map((entry) => ({
        addr: entry.addr!.trim(),
        // 历史版本曾把密码写入 localStorage；读取时立即清除，后续只保留地址。
        pass: '',
        ts: typeof entry.ts === 'number' ? entry.ts : Date.now(),
      }));
    if (arr.some((entry) => typeof entry?.pass === 'string' && entry.pass.length > 0)) {
      localStorage.setItem(HIST_KEY, JSON.stringify(normalized));
    }
    return normalized;
  } catch {
    return [];
  }
}

function saveLanHistory(addr: string, _pass: string): void {
  if (!addr) return;
  const list = loadLanHistory().filter((e) => e.addr !== addr);
  list.unshift({ addr, pass: '', ts: Date.now() });
  try {
    localStorage.setItem(HIST_KEY, JSON.stringify(list.slice(0, 12)));
  } catch {
    // 存储不可用时忽略
  }
  fillAddrDatalist();
  renderLanHistory();
}

function deleteLanHistory(addr: string): void {
  const list = loadLanHistory().filter((e) => e.addr !== addr);
  try {
    localStorage.setItem(HIST_KEY, JSON.stringify(list));
  } catch {
    // ignore
  }
  fillAddrDatalist();
  renderLanHistory();
}

function fillAddrDatalist(): void {
  const dl = document.getElementById('lan-addr-history');
  if (!dl) return;
  dl.innerHTML = loadLanHistory()
    .map((e) => `<option value="${escapeHtml(e.addr)}"></option>`)
    .join('');
}

function renderLanHistory(): void {
  const box = document.getElementById('lan-history');
  if (!box) return;
  const list = loadLanHistory();
  if (list.length === 0) {
    box.innerHTML = '<p class="hint">暂无历史记录</p>';
    return;
  }
  box.innerHTML = list
    .map((e) => {
      const masked = '（密码不会保存）';
      return (
        `<div class="hist-item">` +
        `<button class="hist-fill" data-addr="${escapeHtml(e.addr)}">` +
        `<span class="hist-addr">${escapeHtml(e.addr)}</span>` +
        `<span class="hist-pass">${masked}</span>` +
        `</button>` +
        `<button class="hist-del" data-addr="${escapeHtml(e.addr)}" title="删除" aria-label="删除 ${escapeHtml(e.addr)} 的历史记录"><svg class="site-icon" aria-hidden="true"><use href="#icon-close"></use></svg></button>` +
        `</div>`
      );
    })
    .join('');
}

function lanConnect(): void {
  const addr = ($('lan-addr') as HTMLInputElement).value.trim();
  const pass = ($('lan-passcode') as HTMLInputElement).value;
  const msg = $('lan-msg');
  if (!appState.connectionPreflightCanConnect) {
    msg.textContent = '当前网络或浏览器环境暂时无法连接，请先完成连接前检查。';
    msg.className = 'status err';
    return;
  }
  if (!addr) {
    msg.textContent = '请输入被控端地址';
    msg.className = 'status err';
    ($('lan-addr') as HTMLInputElement).setAttribute('aria-invalid', 'true');
    ($('lan-addr') as HTMLInputElement).focus();
    return;
  }
  ($('lan-addr') as HTMLInputElement).removeAttribute('aria-invalid');
  msg.textContent = '';
  // 保存地址+密码到本地历史（受控端已支持无密码直连，故密码可为空）
  saveLanHistory(addr, pass);
  api.serverUrl = getCurrentServerUrl();
  api.token = '';
  api.refreshToken = '';
  api.username = '';
  const accessMode = readSessionMode('lan-mode-picker');
  const connect = async (): Promise<void> => {
    let sessionStarted = false;
    try {
      startSession(accessMode, connect);
      sessionStarted = true;
      const controller = newController();
      appState.controller = controller;
      await controller.connectLan(addr, pass, accessMode);
    } catch {
      if (sessionStarted) {
        appState.cancelSession?.();
        msg.textContent = '暂时无法连接局域网设备，请检查地址和密码后重试。';
        msg.className = 'status err';
      }
    }
  };
  void connect();
}

export {
  loadLanHistory,
  saveLanHistory,
  deleteLanHistory,
  fillAddrDatalist,
  renderLanHistory,
  lanConnect,
};
